export default __webpack_public_path__ + "static/media/Chevron.967e6042.svg";